import actionCreator from '../../createAction';

const createAction = actionCreator('messages');

export const UPDATE_MESSAGE_VALUES = createAction('UPDATE_MESSAGE_VALUES');
export const RESET_NEW_MESSAGE = createAction('RESET_NEW_MESSAGE');
